import { compose, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from 'redux/reducer';
import _groupBy from 'lodash/groupBy';

import { defaultState as changedFieldsDefault } from 'redux/modules/changedFields';

const initStore = initialState => {
    const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    return createStore(
        reducer,
        preprocessData(initialState),
        composeEnhancer(applyMiddleware(thunk))
    );
};

export default initStore;

export function preprocessData(data) {
    const {
        pages,
        sections,
        options,
        settings: {
            form: { formBtnSubmitText }
        }
    } = data;
    data.pages = data.pages.filter(page => page.type !== 3);
    const formPagesId = pages.filter(page => page.type === 1).map(page => page.id);
    let buttonSection;
    let hiddenFieldSection;
    data.sections = sections
        .reduce((newSections, section) => {
            if (section.type === 501 && formPagesId.includes(section.pageId)) {
                buttonSection = section;
                return newSections;
            } else if (section.type === 601) {
                hiddenFieldSection = section;
                return newSections;
            }
            newSections.push(section);
            return newSections;
        }, [])
        .filter(s => s);
    if (hiddenFieldSection) {
        const { hiddenFields, fields } = data.fields.reduce(
            (obj, field) => {
                if (field.sectionId === hiddenFieldSection.id) {
                    obj.hiddenFields.push(field);
                } else {
                    obj.fields.push(field);
                }
                return obj;
            },
            { hiddenFields: [], fields: [] }
        );
        data.hiddenFields = hiddenFields;
        data.fields = fields;
    }
    if (!formBtnSubmitText && buttonSection) {
        const buttonSectionSetting = data.settings.sections.find(s => s.id === buttonSection.id);
        if (buttonSectionSetting) {
            const { displayName } = buttonSectionSetting;
            data.settings.form.formBtnSubmitText = displayName;
            data.changedFields = {
                ...changedFieldsDefault,
                form: true
            };
        }
    }

    const optionsGroupObj = _groupBy(options, 'fieldId');
    data.options = Object.keys(optionsGroupObj).reduce((arr, fieldId) => {
        const resetSeqOptions = optionsGroupObj[fieldId].map((option, index) => {
            return { ...option, seq: index + 1 };
        });
        return [...arr, ...resetSeqOptions];
    }, []);

    // 因 Redux 沒有使用 favIcon 這個 reducer 導致警告 favIcon 會被忽略
    const { favIcon, ...rest } = data;
    return rest;
}
